import Vue from "vue";

Vue.component("multi-select-domains", {
	props: ["viewModelData"],
	computed: {
		placeholder() {
			return htmlEntity.decode(window.labels.domainPlaceHolder);
		},
		domains() {
			return window.multiSelectDomains;
		}
	},
	data() {
		return {
			selectedDomains: []
		};
	},
	watch: {
		selectedDomains: function(val) {
			this.$emit("update:viewModelData", val);
		}
	},
	template: `      
	 	<wto-tag-input-ids :placeholder="placeholder" :items="domains" :ids.sync="selectedDomains"></wto-tag-input-ids>     
	`
});